/*
 * @Author: your name
 * @Date: 2020-11-12 09:47:58
 * @LastEditTime: 2021-06-29 09:15:58
 * @LastEditors: Do not edit
 * @Description: In User Settings Edit
 * @FilePath: \FullPhotoViewer\src\main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
//noinspection ES6UnusedImports
import Bulma from 'bulma';
import HappyScroll from 'vue-happy-scroll';

import iView from 'view-design';
import 'vue-happy-scroll/docs/happy-scroll.css';
import 'vue-slider-component/theme/default.css';
import '@/assets/icon/iconfont.css';
  // 引入css
import 'view-design/dist/styles/iview.css';
import './index.less';
import './reset.less';
import config from '@/config';
import importDirective from '@/directive';
import $ from 'jquery';
import { Button, Scrollbar, Loading, Message, Image, Tooltip } from 'element-ui';
import Viewer from 'v-viewer'
import 'video.js/dist/video-js.css'  //videojs样式
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
	// 需要配置的属性
	toolbar: false,
	navbar:false,
	title:false
  })
// 导入文件
import Driver from 'driver.js'
import 'driver.js/dist/driver.min.css';

import { i18n  } from './i18n/index' 
Vue.prototype.$driver1 = new Driver({
  allowClose: false,
  padding: 0,
  opacity: 0,
})

Vue.prototype.$driver = new Driver({
  allowClose: false,
  padding: 0,
  opacity: 0.7,
  onNext: (v) => {
    let driver = Vue.prototype.$driver
    // 全景
    if(Vue.prototype.$driver.currentStep == 0) {
      store.state.Case.currentMenuIndex = 3
      setTimeout(() => {
        driver.start(1)
      }, 50);
    }
    // 视角
    if(Vue.prototype.$driver.currentStep == 1) {
      store.state.Case.currentMenuIndex = 4
       setTimeout(() => {
         driver.start(2)
       }, 50);
    }
    // 热点
    if(Vue.prototype.$driver.currentStep == 2) {
      store.state.Case.currentMenuIndex = 5
       setTimeout(() => {
         driver.start(3)
       }, 50);
    }
    if(Vue.prototype.$driver.currentStep == 3) {
      store.state.Case.currentMenuIndex = 6
       setTimeout(() => {
         driver.start(4)
       }, 50);
    }
    if(Vue.prototype.$driver.currentStep == 4) {
      store.state.Case.currentMenuIndex = 7
       setTimeout(() => {
         driver.start(5)
       }, 50);
    }
    if(Vue.prototype.$driver.currentStep == 5) {
      store.state.Case.currentMenuIndex = 8
       setTimeout(() => {
         driver.start(6)
       }, 50);
    }
  },
  onPrevious: () => {
    let driver = Vue.prototype.$driver
    // 案例
    if(Vue.prototype.$driver.currentStep == 1) {
      store.state.Case.currentMenuIndex = 2
       setTimeout(() => {
         driver.start(0)
       }, 50);
    }
    // 全景
    if(Vue.prototype.$driver.currentStep == 2) {
      store.state.Case.currentMenuIndex = 3
       setTimeout(() => {
         driver.start(1)
       }, 50);
    }
    // 视角
    if(Vue.prototype.$driver.currentStep == 3) {
      store.state.Case.currentMenuIndex = 4
       setTimeout(() => {
         driver.start(2)
       }, 50);
    }
    // 热点
    if(Vue.prototype.$driver.currentStep == 4) {
      store.state.Case.currentMenuIndex = 5
       setTimeout(() => {
         driver.start(3)
       }, 50);
    }
    // 音乐
    if(Vue.prototype.$driver.currentStep == 5) {
      store.state.Case.currentMenuIndex = 6
       setTimeout(() => {
         driver.start(4)
       }, 50);
    }
    // 设计师
    if(Vue.prototype.$driver.currentStep == 6) {
     store.state.Case.currentMenuIndex = 7
      setTimeout(() => {
        driver.start(5)
      }, 50);
    }
  },
})

Vue.use(Scrollbar);
Vue.use(Button);
Vue.use(Image);
Vue.use(iView, {
  i18n: function(path, options) {
    let value = i18n.t(path, options)
    if (value !== null && value !== undefined) {
      return value
    }
    return ''
  }
});
Vue.prototype.$message = Message;
Vue.use(HappyScroll)
Vue.use(Tooltip)


/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false;

Vue.prototype.$ = $;
Vue.prototype.$loading = Loading.service;
// Vue.prototype.$previewURL = 'http://localhost:8080/tourdesign' // 本地环境地址
// Vue.prototype.$previewURL = 'https://uat-720.ihomecloud.com.cn/tourview' // 测试环境地址
// Vue.prototype.$previewURL = 'https://720.ihomecloud.com.cn/tourview' // 正式环境地址
Vue.prototype.$previewURL = 'https://720.ihomecloud.com.cn/tourview' // 正式环境地址(新)

/**
 * 注册指令
 */
importDirective(Vue);

/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
});




// WEBPACK FOOTER //
// ./src/main.js